module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightlightrain@3-0e4d7a2e42dbf9ca68afe19cc15d1d93.png";